/**
 * Configuration for connecting to TWC remote APIs
 * "apiConfig" itself is a const but all properties are mutable.
 */

// These values are fallback values. All URLs are pulled from the remote config
// All API keys, except DSP keys are pulled from DSP
export const apiConfig = {
  REMOTE_CONFIG_DEV_URL: 'https://app.staging.twc-tv.com/twc_config.json',
  REMOTE_CONFIG_PROD_URL: 'https://app.twc-tv.com/twc_config.json',
  REMOTE_CONFIG_QA_URL: 'https://app-qa-twc-tv.s3.us-east-1.amazonaws.com/twc_config.json',

  // twc
  TWC_API_KEY: '',
  TWC_API_BASE: 'https://api.weather.com/v3/',
  TWC_API_BASE_V2: 'https://api.weather.com/v2/',
  TWC_API_BASE_V1: 'https://api.weather.com/v1/',
  TWC_API_AIR_QUALITY: 'geocode/:lat/:lng/airquality(/:service).json',
  TWC_API_CURRENT_ON_DEMAND: 'wx/observations/current',
  TWC_API_HOURLY_FORECAST: 'wx/forecast/hourly',
  TWC_API_DAILY_FORECAST: 'wx/forecast/daily',
  TWC_API_ALERTS_HEADLINES: 'alerts/headlines',
  TWC_API_ALERTS_DETAIL: 'alerts/detail',
  TWC_API_POLLEN_INDEX: 'indices/pollen/daypart',
  TWC_API_US_LIGHTNING: 'wx/lightning/recent/conus/5minute',
  TWC_API_MAP_TILE_KEY: '608d667ce77949648d667ce779b96432',
  TWC_API_MAP_TILE_INVENTORY: 'TileServer/series/productSet/PPAcore',
  TWC_API_MAP_TILES_URL: 'TileServer/tile',
  TWC_API_MAP_GRIDDED_INVENTORY: 'tiler/info',
  TWC_API_MAP_GRIDDED_TILE: 'tiler/data',
  TWC_API_MAP_ALERTS_INVENTORY:
    'https://api.weather.com/v2/vector-api/products/{productKey}/info?max-times=1&apiKey=608d667ce77949648d667ce779b96432',
  TWC_API_MAP_ALERTS:
    'https://api.weather.com/v2/vector-api/products/{productKey}/features?time={time}&lod={z}&x={x}&y={y}&apiKey=608d667ce77949648d667ce779b96432',

  // mapbox
  MAPBOX_API_KEY: '',
  MAPBOX_STYLE_URL: 'mapbox://styles/mapbox/streets-v9',
  MAPBOX_PLACES_BASE: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
  MAPBOX_BASE_TILE_TEMPLATE:
    'https://api.mapbox.com/styles/v1/weathergroup/ckzit6dyz000c14ryq3klkvyc/tiles/512/{z}/{x}/{y}',
  MAPBOX_SYMBOL_TILE_TEMPLATE:
    'https://api.mapbox.com/styles/v1/weathergroup/ckzitfdo2000e15s7tx3svhcv/tiles/512/{z}/{x}/{y}',

  // dsp
  DSP_API_KEY: '1aab81e56b0d8ce93d05fd3e30d027de3e9fbf9a',
  //DSP_API_KEY: 'ac591eaefa6c5621d75658fcc177d352c8bf04b2', // dev key, prod key is updated below
  DSP_HOST_URL: 'https://api.myspotlight.tv/',
  VOD_SHOW_DETAILS_URL: 'https://api.myspotlight.tv/channel/US/id/{id}',
  DSP_IMAGE_HOST_URL: 'https://images.dotstudiopro.com/',
  DSP_CUSTOMER_TOKEN_KEY: 'https://wtdev.com/dsp_customer_token',
  DSP_TOKEN_URL: 'https://api.myspotlight.tv/token',
  DSP_TOKEN_REFRESH_URL: 'https://api.myspotlight.tv/users/token/refresh',
  DSP_ADOBE_TOKEN_URL: 'https://api.myspotlight.tv/users/token/adobe?requestor=weatherchannel',
  DSP_CONTINUE_WATCHING: 'https://api.myspotlight.tv/users/resumption/videos',
  DSP_SEND_BOOKMARK_URL: 'https://api.myspotlight.tv/users/videos/point',
  DSP_USER_PRODUCT_URL: 'https://api.myspotlight.tv/subscriptions/users/products?include_inactive_products=true',
  DSP_GET_SUBSCRIPTIONS_URL: 'https://api.myspotlight.tv/subscriptions/summary',
  LIVE_VIDEO_STREAM_URL: 'https://api.myspotlight.tv/video/play/61f2ed2ba59bf5643841ac23/1920/1080',
  LIVE_VIDEO_STREAM_SPANISH_URL: 'https://api.myspotlight.tv/video/play/62c6f3b1535d1e4e06086663/1920/1080',
  LIVE_VIDEO_STREAM_PATTRN_URL: 'https://api.myspotlight.tv/video/play/63bf0c756888722f6e046208/1920/1080',
  LIVE_CHANNEL_INFO_URL: 'https://api.myspotlight.tv/live/epg/US',
  ONBOARDING_LANDING_URL: 'https://api.myspotlight.tv/channel/US/connectedonboarding',
  ONBOARDING_CHOOSE_PLAN_URL: 'https://api.myspotlight.tv/channel/US/connectedchooseplan',
  DSP_VOD_LANDING_URL: 'https://api.myspotlight.tv/appload',
  VOD_VIDEO_STREAM_URL: 'https://api.myspotlight.tv/video/play/{id}/{width}/{height}',
  DSP_KEY_CONFIG_URL: 'channel/US/config',
  AMAZON_LINK_PURCHASE_URL: 'https://api.myspotlight.tv/subscriptions/amazon_fire/customer/parse',

  // adobe
  ADOBE_TVE_SOFTWARE_STATEMENT: '',
  ADOBE_TVE_REGISTER_URL: 'https://api.auth.adobe.com/o/client/register',
  ADOBE_TVE_ACCESS_TOKEN_URL: 'https://api.auth.adobe.com/o/client/token?grant_type=client_credentials',
  ADOBE_TVE_REGCODE_URL:
    'https://api.auth.adobe.com/reggie/v1/weatherchannel/regcode?requestor=weatherchannel&format=json',
  ADOBE_TVE_CHECKAUTHN_URL: 'https://api.auth.adobe.com/api/v1/tokens?authn?requestor=weatherchannel&format=json',
  ADOBE_TVE_CHECKAUTHZ_URL:
    'https://api.auth.adobe.com/api/v1/tokens/authz?requestor=weatherchannel&resource=weatherchannel',
  ADOBE_TVE_AUTHORIZE_URL:
    'https://api.auth.adobe.com/api/v1/authorize?requestor=weatherchannel&format=json&resource=weatherchannel',
  ADOBE_TVE_LOGOUT_URL: 'https://api.auth.adobe.com/api/v1/logout',
  ADOBE_TVE_MVPDLIST_URL: 'https://api.auth.adobe.com/api/v1/config/weatherchannel?format=json',
  ADOBE_SHORT_MEDIA_TOKEN:
    'https://api.auth.adobe.com/api/v1/tokens/media?resource=weatherchannel&requestor=weatherchannel',

  // auth0
  AUTH0_CLIENT_ID: '',
  AUTH0_BASE_URL: 'http://auth-stage.streamtwc.com',
  AUTH0_DEVICE_CODE_URL: 'http://auth-stage.streamtwc.com/oauth/device/code',
  AUTH0_TOKEN_URL: 'http://auth-stage.streamtwc.com/oauth/token',
  AUTH0_START_URL: 'http://auth-stage.streamtwc.com/passwordless/start',

  // segment
  GOOGLE_SEGMENT_WRITE_KEY: '',
  FIRE_SEGMENT_WRITE_KEY: '',
  SAMSUNG_SEGMENT_WRITE_KEY: '',
  X1_SEGMENT_WRITE_KEY: '',
  VIZIO_SEGMENT_WRITE_KEY: null,
  SEGMENT_IDENTIFY_URL: 'https://api.segment.io/v1/identify',
  SEGMENT_TRACK_URL: 'https://api.segment.io/v1/track',
  SEGMENT_ID: '31',

  // localnow
  LOCAL_NOW_API_KEY: '',
  LOCAL_NOW_BASE: 'https://prod.localnowapi.com/',
  LOCAL_NOW_CITY_URL: 'https://prod.localnowapi.com/gis/api/v2/City',

  // ANF
  ANF_API_KEY: '',
  ANF_URL: 'https://prod.localnowapi.com/vod/api/v2/TwcLiveFeed?ChannelId={id}',
  ANF_POLL_INTERVAL: '5',

  // Vizio
  VIZIO_APP_BUNDLE: '',

  // constants
  WEB_SIGN_UP_URL: 'https://d2ufixqq814vug.cloudfront.net/',
  REGISTER_DEVICE_URL: 'https://d2ufixqq814vug.cloudfront.net/activate',
  VIZIO_SIGN_UP_URL: 'https://d2ufixqq814vug.cloudfront.net/vizio',
  SAMSUNG_SIGN_UP_URL: 'https://d2ufixqq814vug.cloudfront.net/samsung',
  X1_SIGN_UP_URL: 'https://d2ufixqq814vug.cloudfront.net/watchnow',
  ANDROID_SIGN_UP_URL: 'https://d2ufixqq814vug.cloudfront.net/atv',
};

export const updateApiConfig = remoteConfig => {
  // production key
  apiConfig.DSP_API_KEY = '1aab81e56b0d8ce93d05fd3e30d027de3e9fbf9a';

  if (!remoteConfig) {
    return;
  }

  const {
    api: { anf, dsp, mapbox, twc, adobe_tve, auth0, segment, localnow, vizio },
    constants,
  } = remoteConfig;

  // twc
  apiConfig.TWC_API_BASE = twc.base_v3;
  apiConfig.TWC_API_BASE_V2 = twc.base_v2;
  apiConfig.TWC_API_BASE_V1 = twc.base_v1;
  apiConfig.TWC_API_AIR_QUALITY = twc.air_quality;
  apiConfig.TWC_API_CURRENT_ON_DEMAND = twc.current_on_demand;
  apiConfig.TWC_API_HOURLY_FORECAST = twc.hourly_forecast;
  apiConfig.TWC_API_DAILY_FORECAST = twc.daily_forecast;
  apiConfig.TWC_API_ALERTS_HEADLINES = twc.alerts_headlines;
  apiConfig.TWC_API_ALERTS_DETAIL = twc.alerts_detail;
  apiConfig.TWC_API_POLLEN_INDEX = twc.pollen_index;
  apiConfig.TWC_API_US_LIGHTNING = twc.us_lightning;
  apiConfig.TWC_API_MAP_TILE_INVENTORY = twc.map_tile_inventory;
  apiConfig.TWC_API_MAP_TILES_URL = twc.base_v3 + twc.map_tiles;

  // mapbox
  apiConfig.MAPBOX_STYLE_URL = mapbox.style_url;
  apiConfig.MAPBOX_PLACES_BASE = mapbox.base + mapbox.places;
  apiConfig.MAPBOX_BASE_TILE_TEMPLATE = mapbox.base + mapbox.base_tile_template_react;
  apiConfig.MAPBOX_SYMBOL_TILE_TEMPLATE = mapbox.base + mapbox.symbol_tile_template;

  // dsp
  apiConfig.DSP_HOST_URL = dsp.base;
  apiConfig.VOD_SHOW_DETAILS_URL = dsp.base + dsp.channel_details;
  apiConfig.DSP_IMAGE_HOST_URL = dsp.image_host;
  apiConfig.DSP_CUSTOMER_TOKEN_KEY = constants.dsp_token_key;
  apiConfig.DSP_TOKEN_URL = dsp.base + dsp.token;
  apiConfig.DSP_TOKEN_REFRESH_URL = dsp.base + dsp.token_refresh;
  apiConfig.DSP_ADOBE_TOKEN_URL = dsp.base + dsp.adobe_token;
  apiConfig.DSP_CONTINUE_WATCHING = dsp.base + dsp.recently_watched_data;
  apiConfig.DSP_SEND_BOOKMARK_URL = dsp.base + dsp.recently_watched_point_add;
  apiConfig.DSP_USER_PRODUCT_URL = dsp.base + dsp.user_products;
  apiConfig.DSP_GET_SUBSCRIPTIONS_URL = dsp.base + dsp.subscriptions_summary;
  apiConfig.ONBOARDING_CHOOSE_PLAN_URL = dsp.base + dsp.onboard_choose_plan;
  apiConfig.LIVE_VIDEO_STREAM_URL = dsp.base + dsp.video_stream;
  apiConfig.LIVE_VIDEO_STREAM_SPANISH_URL = dsp.base + dsp.video_stream_spanish;
  apiConfig.LIVE_CHANNEL_INFO_URL = dsp.base + dsp.live_channel_info;
  apiConfig.ONBOARDING_LANDING_URL = dsp.base + dsp.onboard_landing;
  apiConfig.DSP_VOD_LANDING_URL = dsp.base + dsp.vod_landing;
  apiConfig.DSP_KEY_CONFIG_URL = dsp.base + dsp.key_config;
  apiConfig.AMAZON_LINK_PURCHASE_URL = dsp.base + dsp.amazon_receipt_validation;

  // adobe
  apiConfig.ADOBE_TVE_REGISTER_URL = adobe_tve.base + adobe_tve.o_register;
  apiConfig.ADOBE_TVE_ACCESS_TOKEN_URL = adobe_tve.base + adobe_tve.o_access_token;
  apiConfig.ADOBE_TVE_REGCODE_URL = adobe_tve.base + adobe_tve.regcode;
  apiConfig.ADOBE_TVE_CHECKAUTHN_URL = adobe_tve.base + adobe_tve.checkauthn;
  apiConfig.ADOBE_TVE_AUTHORIZE_URL = adobe_tve.base + adobe_tve.authorize;
  apiConfig.ADOBE_TVE_LOGOUT_URL = adobe_tve.base + adobe_tve.logout;
  apiConfig.ADOBE_TVE_MVPDLIST_URL = adobe_tve.base + adobe_tve.mvpd_list;

  // auth0
  apiConfig.AUTH0_BASE_URL = auth0.base;
  apiConfig.AUTH0_DEVICE_CODE_URL = auth0.base + auth0.device_code;
  apiConfig.AUTH0_TOKEN_URL = auth0.base + auth0.token;
  apiConfig.AUTH0_START_URL = auth0.base + auth0.start;

  // segment
  apiConfig.SEGMENT_IDENTIFY_URL = segment.base + segment.identify;
  apiConfig.SEGMENT_TRACK_URL = segment.base + segment.track;

  // localnow
  apiConfig.LOCAL_NOW_BASE = localnow.base;
  apiConfig.LOCAL_NOW_CITY_URL = localnow.base + localnow.city;

  // ANF
  apiConfig.ANF_URL = anf.base;
  apiConfig.ANF_POLL_INTERVAL = anf.poll_interval;

  // Vizio
  apiConfig.VIZIO_APP_BUNDLE = vizio.appBundle;

  // constants
  apiConfig.WEB_SIGN_UP_URL = constants.web_signup_url;
  apiConfig.VIZIO_SIGN_UP_URL = constants.vizio_signup_url;
  apiConfig.ANDROID_SIGN_UP_URL = constants.android_signup_url;
  apiConfig.X1_SIGN_UP_URL = constants.x1_signup_url;
  apiConfig.SAMSUNG_SIGN_UP_URL = constants.samsung_signup_url;
  apiConfig.REGISTER_DEVICE_URL = constants.register_device_url;
  apiConfig.SEGMENT_ID = segment.segment_id;
};

export const updateApiKeyConfig = config => {
  const keyList = config.channels[0].story_blocks;

  apiConfig.AUTH0_CLIENT_ID = getApiKeyValue(keyList, 'AUTH0_CLIENT_ID');

  apiConfig.TWC_API_KEY = getApiKeyValue(keyList, 'TWC_IBM_API_KEY');

  apiConfig.LOCAL_NOW_API_KEY = getApiKeyValue(keyList, 'LOCAL_NOW_API_KEY');

  apiConfig.ANF_API_KEY = getApiKeyValue(keyList, 'ANF_API_KEY');

  apiConfig.TWC_API_MAP_TILE_KEY = getApiKeyValue(keyList, 'TWC_API_MAP_TILE_KEY');

  apiConfig.MAPBOX_API_KEY = getApiKeyValue(keyList, 'MAPBOX_API_KEY');

  const adobe = getApiKeyValue(keyList, 'ADOBE_TVE_API_KEY');

  apiConfig.ADOBE_TVE_SOFTWARE_STATEMENT = adobe;

  apiConfig.GOOGLE_SEGMENT_WRITE_KEY = getApiKeyValue(keyList, 'GOOGLE_SEGMENT_WRITE_KEY');

  apiConfig.FIRE_SEGMENT_WRITE_KEY = getApiKeyValue(keyList, 'AMAZON_SEGMENT_WRITE_KEY');

  apiConfig.X1_SEGMENT_WRITE_KEY = getApiKeyValue(keyList, 'X1_SEGMENT_WRITE_KEY');

  apiConfig.SAMSUNG_SEGMENT_WRITE_KEY = getApiKeyValue(keyList, 'SAMSUNG_SEGMENT_WRITE_KEY');

  apiConfig.VIZIO_SEGMENT_WRITE_KEY = getApiKeyValue(keyList, 'VIZIO_SEGMENT_WRITE_KEY');

  // add mapbox API keys to template URLs
  apiConfig.MAPBOX_BASE_TILE_TEMPLATE += `?access_token=${apiConfig.MAPBOX_API_KEY}`;
  apiConfig.MAPBOX_SYMBOL_TILE_TEMPLATE += `?access_token=${apiConfig.MAPBOX_API_KEY}`;
};

const getApiKeyValue = (list, name) => list.find(k => k.name === name)?.detail?.headline;
